import { render, staticRenderFns } from "./AccountSettingWholesalers.vue?vue&type=template&id=5b0a0cac&scoped=true&"
import script from "./AccountSettingWholesalers.vue?vue&type=script&lang=js&"
export * from "./AccountSettingWholesalers.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingWholesalers.vue?vue&type=style&index=0&id=5b0a0cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a0cac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
